export default __webpack_public_path__ + "90b54f6de3b8971b96eeb56763ffaa28.svg";